import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { GET_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED, START_LOADING, STOP_LOADING } from "./actionType";



import { allLeadsApiResponseError, allLeadsApiResponseSuccess } from "./action";
import { postAllLeadsAccountOpned } from "../../../api/fakebackend_helper";

function* AllLeads(data) {
    try {
        // yield put({ type: START_LOADING });
        const response = yield call(postAllLeadsAccountOpned, data.payload);
        yield put(allLeadsApiResponseSuccess(GET_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED, response));
        // yield put({ type: STOP_LOADING });
    } catch (error) {
        yield put(allLeadsApiResponseError(GET_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED, error));
        // yield put({ type: STOP_LOADING });
    }
}

export function* watchGetCart() {
    yield takeEvery(GET_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED, AllLeads);
}

function* AllLeadsSaga() {
    yield all([fork(watchGetCart)]);
}

export default AllLeadsSaga;
